import { styled } from '@mui/material';

import { I18nResources } from '@app-velocity/i18n';

import { SingleStat } from './components/SingleStat';

export type StatsProps = {
  stats: {
    value?: string | number;
    label: I18nResources;
  }[];
};

const SummaryContainer = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: theme.spacing(2),
  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: '1fr 1fr 1fr',
  },
}));

export const Stats = ({ stats }: StatsProps) => {
  const formatValue = (value?: null | number | string) => {
    if (typeof value === 'undefined') return '-';
    if (value === null) return '-';

    return value;
  };

  return (
    <SummaryContainer>
      {stats.map((stat, index) => (
        <SingleStat
          key={index}
          label={stat.label}
          value={formatValue(stat.value)}
        />
      ))}
    </SummaryContainer>
  );
};
